import React, {Component} from 'react';
import { connect } from 'react-redux';
import Header from '../base/header';
import Borradores from './borradores';
import CrearNuevo from './crearNuevo';
import Simulacion from './simulacion';
import SimulacionReactiva from './simulacionReactiva';
import CargaMasiva from './cargaMasiva';
import api from '../../utils/api';

class Simulador extends Component {

    constructor(props) {
        super(props);

        this.state = {
            isStep1: true,
            isStep2: false,
            isStep3: false,
            isStep4: false,
            isStep5:false,
            editId: null,
            isLoading: true,
            simulador: {}
        };
        this.switchToStep = this.switchToStep.bind(this);
        this.setEditId = this.setEditId.bind(this);
    }

    setEditId(id){
        let _state = this.state;
        _state.editId = id;
        if(this.state.simulador && this.state.simulador.name){
            window.history.pushState('simulador', this.state.simulador.name, '/simulador/editar/' + id);
        }
        this.setState(_state);
    }

    switchToStep(step, simulador) {
      let _state = this.state;

      _state.isStep1 = step === 1;
      _state.isStep2 = step === 2;
      _state.isStep3 = step === 3;
      _state.isStep4 = step === 4;
      _state.isStep5 = step === 5;
      _state.isLoading = false;
      _state.simulador = simulador;

      this.setState(_state);
    }

    componentWillMount(){
        let _self = this;
        let _state = _self.state;
        let { cluster_id, cluster_name } = _self.props.match.params;

        if (cluster_id === 'nuevo' || cluster_id === 'editar') {
          api.get('simulations/id/' + cluster_name).then(resp => {
            let step = resp.data.simulation_type === "REACTIVE" ? 4 : resp.data.simulation_type==="PROACTIVE"? 3: 5;
            resp.data.type = resp.data.simulation_type;
            _self.setEditId(resp.data.id);
            _self.switchToStep(step, resp.data); 
          })
        } else if(cluster_id) {
            let simulador = _state.simulador;
            simulador.name = ' Simulación Reactiva: ' + cluster_name;
            simulador.type = 'REACTIVE';
            simulador.cluster_id = cluster_id;
            _self.switchToStep(2, simulador);
        } else {
          this.setState({
            isLoading: false
          });
        }
    }

    render(){
        return (
            <div>
                <Header history={this.props.history} />
                {!this.state.isLoading && this.state.isStep1 ? <Borradores switchToStep={this.switchToStep} setEditId={this.setEditId} /> : ''}
                {!this.state.isLoading && this.state.isStep2 ? <CrearNuevo simulador={this.state.simulador} switchToStep={this.switchToStep} setEditId={this.setEditId} /> : ''}
                {!this.state.isLoading && this.state.isStep3 ? <Simulacion switchToStep={this.switchToStep} setEditId={this.setEditId} editId={this.state.editId}/> : ''}
                {!this.state.isLoading && this.state.isStep4 ? <SimulacionReactiva switchToStep={this.switchToStep} setEditId={this.setEditId} editId={this.state.editId}/> : ''}
                {!this.state.isLoading && this.state.isStep5 ? <CargaMasiva switchToStep={this.switchToStep} setEditId={this.setEditId} editId={this.state.editId}/>:''}
            </div>
        );
    }

}

const mapStateToProps = (state) => {
    return {
        user: state.user
    }
}

export default connect(mapStateToProps)(Simulador);



// WEBPACK FOOTER //
// ./src/containers/simulador/simulador.js